package com.artvending.warden

class TimeInterval(val from: Int?, val to: Int?)